<template>
  <div class="main-content">
    <div class="map-container">
      <SelectOrdersMap
        v-if="divId"
        :divisionId="divId"
        :noAction="1"
      />
<!--      <div>-->
<!--        <iframe style="width: 100%; height: 500px"-->
<!--                :src="`https://map.assistance10.com/show?u=${$currentUID}&k=${generateKey()}`" frameborder="0"></iframe>-->
<!--      </div>-->
      <!--      <YandexMap style="width: 100%; height: 500px" :settings="settings" :coordinates="coords">-->

      <!--      <yandex-map :settings="settings" :coords="coords" zoom="9">-->
      <!--Markers-->
      <!--          v-for="marker in markers"-->
      <!--            :coords="[55.756163, 37.621756]"-->
      <template v-if="false" v-for="marker in markers">
        <ymap-marker
          :marker-id="marker.id"
          @click="(e) => openOrder(e, marker.id)"
          @dragend="(e) => updateCoords(e, marker.id)"
          marker-type="Placemark"
          :options="{draggable:true}"
          :coords="marker.extra_options.geo_coordinates.coords"
          :icon="{color: 'green', content:marker.line_order}"
        >
          <div slot="balloon">
            <div class="balloon_div" :id="`balloon_div_${marker.id}`">
              <p>Заявка: <strong>{{ ('' + marker.id).substr(-4) }}</strong></p>
              <p>Адрес: {{ marker.address }}</p>
              <div class="">
                <div class="input-group mb-3 mt-2">
                  <input type="number" :data-orderId="marker.id" :ref="`newLineNum_${marker.id}`"
                         placeholder="Номер по списку" class="form-control"/>
                  <LoadingButton
                    title="Сохранить номер"
                    className="btn btn-outline-success btn_line_number"
                    :loading="btnLoading"
                    :onClick="() => updateOrder(marker.id, 'line_number')"
                  />
                </div>
                <LoadingButton
                  title="Сохранить текущую позицию"
                  className="btn btn-outline-info w-100 btn_geo_position"
                  :loading="btnLoading"
                  :onClick="() => updateOrder(marker.id, 'geo_position')"
                />
              </div>
            </div>
          </div>
        </ymap-marker>
      </template>
      <!--      </yandex-map>-->
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import {yandexMap, ymapMarker} from 'vue-yandex-maps'
import SelectOrdersMap from "@/components/map/SelectOrdersMap.vue";
// import {YandexMap, YandexMarker} from 'vue-yandex-maps'

export default {
  components: {
    SelectOrdersMap,
    LoadingButton,
    // YandexMap,
    yandexMap,
    ymapMarker,
  },
  data() {
    return {
      divId: null,
      loading: false,
      btnLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      orders: null,
      coords: [55.756163, 37.621756],
      markers: [],
      newCoords: {},
      newLineNum: null,
      settings: {
        // apiKey: '163d60f7-b60c-4b61-ba5f-3f9628e8b0e6',
        // apiKey: '67817bfa-f25e-44c0-afea-fb8904963d00',
        // apiKey: 'f8446710-1e24-4794-9478-2ad0f85f530b',
        // apiKey: 'd431d1fb-9746-4de7-a872-e03b7dd5c805',
        // apiKey: 'a72fac01-1991-4245-8329-5d17b343467c',
        apiKey: '0b84ca7c-7867-4726-8c4d-6f51a00a8a21',
        lang: 'ru_RU',
        coordorder: 'latlong',
        enterprise: false,
        version: '2.1'
      },
    }
  },
  computed: {
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  mounted() {
    this.divId = Object.values(this.$UserDetails).find((d) => d.alias === 'division_id')?.details;
    this.getOrders();
  },
  methods: {
    async updateOrder(id, type) {
      this.btnLoading = true;
      let lineNum = false;
      if (type === 'line_number') {
        lineNum = document.querySelector('input[data-orderId="' + id + '"]').value;
        if (!lineNum) {
          toastr["warning"]("Укажите порядковый номер заявки", "Ошибка");
          this.btnLoading = false;
          return;
        }
      }
      if (type === 'geo_position') {
        if (!this.newCoords[id]) {
          toastr["warning"]("Нет данных для позиции", "Ошибка");
          return;
        }
      }
      const {data} = await api.post('orders/updateOrderByRunner', {
        type: type,
        order_id: id,
        data: {line_number: lineNum, coords: this.newCoords[id]}
      })
      if (data.success) {
        if (type === 'line_number') {
          const markers = [];
          data.orders.map((o) => {
            if (o.extra_options.geo_coordinates && o.extra_options.geo_coordinates.coords) {
              markers.push(o);
            }
          })
          this.markers = [...markers];
          this.orders = data.orders;
          // const index = this.markers.findIndex((m) => m.id === id);
          // this.markers[index].line_order = lineNum;
        } else {
          this.markers = [...this.markers];
        }
        toastr["success"]("сохранено", "Успешно");
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.btnLoading = false;
    },
    updateCoords(e, id) {
      console.log('update', id, e.get('target').geometry.getCoordinates());
      this.newCoords[id] = e.get('target').geometry.getCoordinates();
    },
    openOrder(e, orderId) {
      console.log(e.get('coords'));
      const order = this.orders.find((o) => o.id === orderId);
      this.newLineNum = order.line_order;
      // console.log(this.$refs['newLineNum_' + orderId]);
      // this.$refs['newLineNum_' + orderId][0].value = +order.line_order;
      setTimeout(() => {
        document.querySelector('#balloon_div_' + orderId + ' .btn_line_number').addEventListener('click', (e) => {
          this.updateOrder(orderId, 'line_number')
        }, false);
        document.querySelector('#balloon_div_' + orderId + ' .btn_geo_position').addEventListener('click', (e) => {
          this.updateOrder(orderId, 'geo_position')
        }, false);
        document.querySelector('input[data-orderId="' + orderId + '"]').value = +order.line_order;
      }, 100);


    },
    generateKey() {
      return 1;
    },
    async updateOrders(e) {
      console.log(e, 1);
    },
    async getOrders() {
      this.loading = true;
      const {data} = await api.index('orders/gerRunnerOrders');
      if (data.success) {
        // const actionBtnLoading = {};
        // const actions = {};
        // const url = `https://geocode-maps.yandex.ru/1.x/?apikey=${this.settings.apiKey}&format=json&geocode=${data.orders[0].address}`
        // console.log(data.orders[0].address, url);
        const markers = [];
        data.orders.map((o) => {
          // actionBtnLoading[o.id] = false;
          // actions[o.id] = {...this.defaultState}
          if (o.extra_options.geo_coordinates && o.extra_options.geo_coordinates.coords) {
            markers.push(o);
          }

        })
        this.markers = [...markers];
        // this.actionBtnLoading = {...actionBtnLoading};
        // this.actions = {...actions};
        this.orders = data.orders;
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.balloon_div {
  max-width: 75vw;
}

.map-container {
  height: 80vh;
}

.ymap-container {
  height: 100%;
}
</style>
